import React from "react";
import "./App.scss";

export default function App() {
  console.log(`window:`, window.scrollY);
  return (
    <div>
      <h1>Home Page yey!</h1>
    </div>
  );
}
